import React from 'react'
import { QuickSignupForm } from 'spa/member/components/Top/QuickSignupPanel/QuickSignupForm'
import { Button } from 'spa/member/components/v2/Button'
import styles from './QuickSignupPanel.module.scss'
import { SocialSignupModal } from './SocialSignupModal'
import { SocialSignupPanelProps } from './types'

export const StyledQuickSignupPanel: React.FC<SocialSignupPanelProps> = (props: SocialSignupPanelProps) => {
  return (
    <div className={`${styles.container}`}>
      <div className="border-bottom border-gray-300">
        <div className="text-center text-L font-bold text-member-green-100 pb-XL">
          無料会員登録
        </div>
        <QuickSignupForm />
        <div className={`relative text-center ${styles.socialSigninLink}`}>
          {props.socialSignupModalIsOpen && (
            <div className="absolute top-0 right-0 w-max" style={{ transform: 'translateY(-100%)' }}>
              <SocialSignupModal onClose={props.toggleSocialSignupModal} />
            </div>
          )}
          <a
            onClick={props.toggleSocialSignupModal}
            className={`text-member-green-100 text-XS font-bold border-b-1 border-member-green-100 cursor-pointer ${styles.socialSignUpLink}`}
            tabIndex={0}
          >
            クラウドワークス・その他アカウントで登録する
          </a>
        </div>
      </div>
    <div className="flex justify-center w-full">
      <Button kind="secondary" onClick={props.onLoginButtonClick} className="mt-XL all:w-full tablet:w-80">
        会員の方はこちらからログイン
      </Button>
    </div>
  </div>
  )
}
